import React from 'react'
import { MetaTags } from 'react-meta-tags'
import Typography from '@material-ui/core/Typography'
import Title from 'ui/Title'

export default () => (
  <React.Fragment>
    <Title mt={4}>404 Error: Page Not Found</Title>
    <MetaTags>
      <meta name="prerender-status-code" content="404" />
    </MetaTags>
    <Typography
      variant="subtitle1"
      color="textSecondary"
      css={{ textAlign: 'center' }}
    >
      Sorry, the page you are looking for is not available.
    </Typography>
  </React.Fragment>
)
